import { useEffect, useMemo } from 'react';
import { setFlowIAScreenContext } from './flowIAScreenContextStore';

/**
 * Registra contexto seguro para Flow IA en la pantalla actual (sin tokens ni PII sensible).
 * @param {Record<string, unknown>} context
 */
export function useFlowIAScreenContext(context) {
  const stable = useMemo(() => ({ ...(context || {}) }), [context]);
  useEffect(() => {
    setFlowIAScreenContext(stable);
    return () => setFlowIAScreenContext({});
  }, [stable]);
}
